import { useCallback } from 'react';

/**
 * Hook to manage bonus streak timer countdown
 *
 * NOTE: Timer interval logic has been moved to GameApp.tsx to ensure
 * a single source of truth. The timer is controlled via Redux state:
 * - isTimerRunning: true starts the timer (set by startBonusStreak/continueBonusStreak)
 * - isTimerRunning: false stops the timer (set by breakBonusStreak/updateStreakTimer when time=0)
 *
 * This hook now returns no-op functions to maintain API compatibility
 * with existing code that calls startTimer/stopTimer.
 */
export const useStreakTimer = () => {
  // No-op: Timer is now managed by GameApp watching isTimerRunning from Redux
  const startTimer = useCallback(() => {
    // Timer automatically starts when isTimerRunning is set to true in Redux
    // by startBonusStreak or continueBonusStreak actions
  }, []);

  const stopTimer = useCallback(() => {
    // Timer automatically stops when isTimerRunning is set to false in Redux
    // by breakBonusStreak action or updateStreakTimer when time reaches 0
  }, []);

  return { startTimer, stopTimer };
};
